class Form {

    /**
     * Validate Login
     * @param str 
     * @returns boolean
     */
    static validEmail(str: any) {
        let regex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
        return regex.test(str);
    }

    /**
     * Minimum length of string
     * @param str 
     * @param length 
     * @returns 
     */
    static minLength(str:any, length:any) {
        let isInvalid = false;

        if (str.length < length) {
            isInvalid = true;
        }

        return isInvalid;
    }

    /**
     * Form Validator
     * @param  obj 
     * @returns 
     */
    //@ts-ignore
    static validator(obj) {
        let keys = Object.entries(obj);
        //@ts-ignore
        let results = [];
        let validations = null;

        keys.map((key) => {
            //@ts-ignore
            if ('isRequired' in key[1] && key[1].isRequired) {
                //@ts-ignore
                if (key[1].value.length === 0) {
                    results.push({
                        [key[0]]: [`The ${key[0]} is required.`]
                    });
                } else {
                    if ('isEmail' in key[1] && key[1].isEmail) {
                        //@ts-ignore
                        let isValidEmail = Form.validEmail(key[1].value);

                        if (!isValidEmail) {
                            results.push({
                                [key[0]]: [`The ${key[0]} must be valid email.`]
                            });
                        }
                    }
//@ts-ignore
                    if ('minLength' in key[1] && Form.minLength(key[1].value, key[1].minLength)) {
                        results.push({
                            [key[0]]: [`The ${key[0]} must at least ${key[1].minLength} characters.`]
                        });
                    }
                }//@ts-ignore
            } else if ('isEmail' in key[1]) {//@ts-ignore
                let isValidEmail = Form.validEmail(key[1].value);

                if (!isValidEmail) {
                    results.push({
                        [key[0]]: [`The ${key[0]} must be valid email`]
                    });
                }//@ts-ignore
            } else if ('minLength' in key[1] && Form.minLength(key[1].value, key[1].minLength)) {
                results.push({
                    [key[0]]: [`The ${key[0]} must at least ${key[1].minLength} characters.`]
                });
            }
            //@ts-ignore
            return results
        })
//@ts-ignore
        results = Object.assign({}, ...results.map((result) => result))

        if (Object.keys(results).length > 0) {
            validations = {
                errors: results
            }
        } else {
            validations = null
        }

        return validations;
    }
}

export default Form